import React, { Component } from "react";
import { getTotalUserReports, setHolidayRequest } from "./actions";
import { selectHolidayRequests, selectHolReqPostFail } from "./selectors";
import { connect } from "react-redux";
import {
    Typography,
    Button,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
    Snackbar,
    SnackbarContent
} from "@material-ui/core";
import { Card, CardHeader, CardBody } from "reactstrap";

class HolidayRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            postReqFail: false
        };
        props.getTotalUserReports();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.postReqFail !== this.props.postReqFail) {
            this.setState({ postReqFail: true });
        }
    }
    render() {
        let requests =
            this.props.holidayRequests === undefined ? undefined : this.props.holidayRequests;

        return (
            <Card>
                <CardHeader>
                    <Typography variant="headline">Holiday Requests</Typography>
                </CardHeader>

                <CardBody>
                    <div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        <Typography variant="body2">
                                            <b>User Name</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Submission Date</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>From Date</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>To Date</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Status</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Actions</b>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {requests !== undefined &&
                                    requests.map((e, i) => {
                                        return (
                                            <TableRow key={i}>
                                                <TableCell component="th" scope="row">
                                                    <Typography variant="body1">
                                                        {e.username}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.submission_date}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.from_date}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.to_date}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography
                                                        variant="body1"
                                                        color={
                                                            e.status === "Approved"
                                                                ? "primary"
                                                                : "secondary"
                                                        }
                                                    >
                                                        {e.status}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Button
                                                        style={{
                                                            width: "8vw",
                                                            marginRight: 5
                                                        }}
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            this.props.setHolidayRequest(
                                                                e.uid,
                                                                e.submission_date,
                                                                "Approved"
                                                            );
                                                        }}
                                                    >
                                                        Approve
                                                    </Button>
                                                    <Button
                                                        style={{ width: "4vw", marginLeft: 5 }}
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => {
                                                            this.props.setHolidayRequest(
                                                                e.uid,
                                                                e.submission_date,
                                                                "Denied"
                                                            );
                                                        }}
                                                    >
                                                        Deny
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </div>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        autoHideDuration={6000}
                        open={this.props.postReqFail}
                        onClose={() => {
                            this.setState({ postReqFail: false });
                        }}
                    >
                        <SnackbarContent message="Unable to Approve Holiday Request, Please Contact Admin" />
                    </Snackbar>
                </CardBody>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            holidayRequests: selectHolidayRequests(store),
            postReqFail: selectHolReqPostFail(store)
        };
    },
    { getTotalUserReports, setHolidayRequest }
)(HolidayRequest);
